export const REGION_DICTIONARY: {[region:string]: string} = {
    "us-east-1": "US East (N. Virginia)",
    "us-west-2": "US West (Oregon)",
    "us-west-1": "US West (N. California)",
    "eu-west-1": "Europe (Ireland)",
    "eu-central-1": "Europe (Frankfurt)",
    "ap-southeast-1": "Asia Pacific (Singapore)",
    "ap-northeast-1": "Asia Pacific (Tokyo)",
    "ap-southeast-2": "Asia Pacific (Sydney)",
    "ap-southeast-3": "Asia Pacific (Jakarta)",
    "ap-northeast-2": "Asia Pacific (Seoul)",
    "ap-south-1": "Asia Pacific (Mumbai)",
    "ap-east-1": "Asia Pacific (Hong Kong)",
    "ap-northeast-3": "Asia Pacific (Osaka)",
    "ap-southeast-4": "Asia Pacific (Melbourne)",
    "sa-east-1": "South America (São Paulo)",
    "us-east-2": "US East (Ohio)",
    "eu-west-2": "Europe (London)",
    "eu-south-2": "Europe (Spain)",
    "eu-central-2": "Europe (Zurich)",
    "ca-central-1": "Canada (Central)",
    "af-south-1": "Africa (Cape Town)",
    "eu-north-1": "Europe (Stockholm)",
    "eu-south-1": "Europe (Milan)",
    "me-south-1": "Middle East (Bahrain)",
    "me-central-1": "Middle East (UAE)",
    "brazilsouth": "(South America) Brazil South",
    "centralindia": "(Asia Pacific) Central India",
    "southeastasia": "(Asia Pacific) Southeast Asia",
    "eastus": "(US) East US",
    "westus": "(US) West US",
    "francesouth": "(Europe) France South",
    "uksouth": "(Europe) UK South",
    "centralus": "(US) Central US",
    "canadacentral": "(Canada) Canada Central",
    "canadaeast": "(Canada) Canada East",
    "koreacentral": "(Asia Pacific) Korea Central",
    "northeurope": "(Europe) North Europe",
    "northcentralus": "(US) North Central US",
    "japaneast": "(Asia Pacific) Japan East",
    "eastasia": "(Asia Pacific) East Asia",
    "australiaeast": "(Asia Pacific) Australia East",
    "southcentralus": "(US) South Central US",
    "westus2": "(US) West US 2",
    "westus3": "US) West US 3",
    "eastus2": "(US) East US 2",
    "swedencentral": "(Europe) Sweden Central",
    "francecentral": "(Europe) France Central",
    "westeurope": "(Europe) West Europe",
    "southafricanorth": "(Africa) South Africa North",
    "jioindiawest": "(Asia Pacific) Jio India West",
    "germanywestcentral": "(Europe) Germany West Central",
    "norwayeast": "(Europe) Norway East",
    "switzerlandnorth": "(Europe) Switzerland North",
    "uaenorth": "(Middle East) UAE North",
    "centralusstage": "(US) Central US (Stage)",
    "eastusstage": "(US) East US (Stage)",
    "eastus2stage": "(US) East US 2 (Stage)",
    "northcentralusstage": "(US) North Central US (Stage)",
    "southcentralusstage": "(US) South Central US (Stage)",
    "westusstage": "(US) West US (Stage)",
    "westus2stage": "(US) West US 2 (Stage)",
    "asia": "Asia",
    "asiapacific": "Asia Pacific",
    "australia": "Australia",
    "brazil": "Brazil",
    "canada": "Canada",
    "europe": "Europe",
    "france": "France",
    "germany": "Germany",
    "global": "Global",
    "india": "India",
    "japan": "Japan",
    "korea": "Korea",
    "norway": "Norway",
    "southafrica": "South Africa",
    "switzerland": "Switzerland",
    "uae": "United Arab Emirates",
    "uk": "United Kingdom",
    "unitedstates": "United States",
    "unitedstateseuap": "United States EUAP",
    "eastasiastage": "(Asia Pacific) East Asia (Stage)",
    "southeastasiastage": "(Asia Pacific) Southeast Asia (Stage)",
    "centraluseuap": "(US) Central US EUAP",
    "eastus2euap": "(US) East US 2 EUAP",
    "southafricawest": "(Africa) South Africa West",
    "jioindiacentral": "(Asia Pacific) Jio India Central",
    "germanynorth": "(Europe) Germany North",
    "norwaywest": "(Europe) Norway West",
    "switzerlandwest": "(Europe) Switzerland West",
    "uaecentral": "(Middle East) UAE Central",
    "brazilsoutheast": "(South America) Brazil Southeast",
    "eu-west-3": "Europe (Paris)",
    "westcentralus": "West Central US (Wyoming)",
    "australiacentral": "Australia Central (Canberra)",
    "australiacentral2": "Australia Central 2 (Canberra)",
    "australiasoutheast": "Australia Southeast (Victoria)",
    "japanwest": "Japan West (Osaka)",
    "koreasouth": "Korea South (Busan)",
    "southindia": "South India (Chennai)",
    "westindia": "West India (Mumbai)",
    "ukwest": "UK West (Cardiff)",
    "il-central-1": "Israel (Tel Aviv)"
};
